module.exports = __webpack_public_path__ + "static/media/aluminium_windows.cae57cac.pdf";